<template>
    <div class="relative py-4">
        <div
            class="text-gray-400 bg-l absolute leading-[14px]  top-[10px] font-bold text-[10px] tracking-[.8px] bg-white text-lGray-700 z-20 pr-3">
            <slot/>
        </div>
        <div class="w-full h-[0px] border border-gray-200"/>
    </div>
</template>
